<h2 mat-dialog-title>EDIT TEST</h2>
<div mat-dialog-content>

  @if (testForm) {
    <form [formGroup]="testForm" (ngSubmit)="onSubmit()">
      <mat-form-field class="full-width">
        <mat-label>Name</mat-label>
        <input matInput placeholder="Name" formControlName="Name">
      </mat-form-field>
      <mat-form-field class="full-width">
        <mat-label>Description</mat-label>
        <input matInput placeholder="Description" formControlName="Description">
      </mat-form-field>
      <mat-form-field class="full-width">
        <mat-label>Result type</mat-label>
        <mat-select formControlName="ResultType" id="ResultType">
          <mat-option  value="10" >
            Integer
          </mat-option>
          <mat-option  value="20" >
            Numeric, 1 decimals
          </mat-option>
          <mat-option  value="21" >
            Numeric, 2 decimal
          </mat-option>
          <mat-option  value="30" >
            Time
          </mat-option>
          <mat-option  value="40" >
            Text
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="full-width">
        <mat-label>Value unit</mat-label>
        <mat-select formControlName="ResultUnit" id="ResultUnit">
          <mat-option  value="reps">
            reps
          </mat-option>
          <mat-option  value="kg">
            kg
          </mat-option>
          <mat-option  value="m">
            m
          </mat-option>
          <mat-option  value="cm">
            cm
          </mat-option>
          <mat-option  value="hh:mm:ss">
            hh:mm:ss
          </mat-option>
          <mat-option  value="s">
            seconds
          </mat-option>
          <mat-option  value="-">
            No unit
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="full-width">
        <mat-label>Abbreviation</mat-label>
        <input matInput placeholder="Abbreviation" formControlName="Abbreviation" maxlength="20">
        <mat-hint>Only needed when using the test in limit formulas</mat-hint>
      </mat-form-field>
      <br/>
      <br/>
      <button mat-raised-button color="primary" [disabled]="!testForm.valid" type="submit" >SAVE</button>&nbsp;
      <button mat-button  type="button" [mat-dialog-close]="false" >CANCEL</button>
    </form>
  }


</div >

